import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackFiltersRemoved } from "@air/analytics";
import React, { memo, useCallback } from "react";
import { CollapsibleCard } from "~/components/CollapsibleCard";
import { FilterCardFooter } from "~/components/Filters/FilterCardFooter";
import { FilterSelect } from "~/components/FiltersMenu/FilterSelect";
import { FILTER_CARD } from "~/constants/testIDs";
import { filterTypeToTrackingType } from "~/store/filters/utils";
export const FilterCard = /*#__PURE__*/ memo((param)=>{
    let { children, onClearClick, currentFilter, onFilterTypeChange, currentCustomField, getFiltersOptions, trackLocation, onRemoveFilter } = param;
    const { trackFiltersRemoved } = useTrackFiltersRemoved();
    const onFilterDelete = useCallback(()=>{
        const filter = {
            type: currentFilter,
            customField: currentCustomField
        };
        onRemoveFilter(filter);
        trackFiltersRemoved({
            types: filterTypeToTrackingType(filter.type),
            location: trackLocation,
            builderType: "filter-builder"
        });
    }, [
        currentCustomField,
        currentFilter,
        onRemoveFilter,
        trackLocation,
        trackFiltersRemoved
    ]);
    return /*#__PURE__*/ _jsx(CollapsibleCard, {
        testId: (currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.id) ? "".concat(FILTER_CARD, "-").concat(currentCustomField.name) : "".concat(FILTER_CARD, "-").concat(currentFilter),
        header: /*#__PURE__*/ _jsx(FilterSelect, {
            getFiltersOptions: getFiltersOptions,
            onFilterSelect: onFilterTypeChange,
            currentFilter: currentFilter,
            currentCustomField: currentCustomField
        }),
        footer: /*#__PURE__*/ _jsx(FilterCardFooter, {
            onClearClick: onClearClick,
            onDeleteClick: onFilterDelete
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: "p-1",
            children: children
        })
    });
});
FilterCard.displayName = "FilterCard";
